// src/components/common/CollapsibleCell.tsx
import React, { useState } from 'react';
import './CollapsibleCell.css';

interface CollapsibleCellProps {
  content: string;
  summaryText?: string;
  forceCollapse?: boolean; 
}

//const CollapsibleCell: React.FC<CollapsibleCellProps> = ({ content }) => {
const CollapsibleCell: React.FC<CollapsibleCellProps> = ({ content, summaryText }) => {
  // FIXED: Lower threshold from 150 to 80 characters for better UX
  // If content is very short or doesn't exist, don't make it collapsible
  if (!content || content.trim().length === 0) {
    return <div className="analysis-cell-content" style={{ color: '#999', fontStyle: 'italic' }}>::::</div>;
  }

  // FIXED: Use 80 characters as threshold instead of 150
  if (content.length < 25) {
    return <div className="analysis-cell-content">{content}</div>;
  }

  return (
    <details className="collapsible-details">
      <summary className="collapsible-summary">
        {summaryText || 'View Analysis'}
      </summary>
      <div className="analysis-cell-content">
        {content}
      </div>
    </details>
  );
};

export default CollapsibleCell;

